import { useCallback, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";
import { auth } from "../../firebase/firebaseConfig";
import type {
  LoginFormEvent,
  LoginInputChangeEvent,
  UseLoginPageParams,
} from "./types";

export const crearEmailDeUsuario = (usuario: string): string => {
  return `${usuario}@fastadmin.com`;
};

export const normalizarUsuario = (usuario: string): string => {
  return usuario.trim().toLowerCase();
};

export const formularioLoginEsValido = (
  usuario: string,
  contrasena: string
): boolean => {
  return normalizarUsuario(usuario).length > 0 && contrasena.trim().length > 0;
};

export const useLoginPage = ({ navigate }: UseLoginPageParams) => {
  const [usuario, setUsuario] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [isSubmiting, setisSubmiting] = useState(false);

  const handleUsuarioChange = useCallback(
    (event: LoginInputChangeEvent) => {
      setUsuario(event.target.value);
    },
    []
  );

  const handleContrasenaChange = useCallback(
    (event: LoginInputChangeEvent) => {
      setContrasena(event.target.value);
    },
    []
  );

  const handleLoginWithEmailPassword = useCallback(async () => {
    if (isSubmiting) {
      return;
    }

    if (!formularioLoginEsValido(usuario, contrasena)) {
      toast.error("Debes ingresar usuario y contrasena.");
      return;
    }

    const userEmail = crearEmailDeUsuario(normalizarUsuario(usuario));

    try {
      setisSubmiting(true);
      await signInWithEmailAndPassword(
        auth,
        userEmail,
        contrasena
      );

      navigate("/home");

      toast.info("Cargando datos");
    } catch (error: any) {
      toast.error("El usuario o la contrasena son incorrectos.");
      console.error("Error de inicio de sesion:", error?.message);
    } finally {
      setisSubmiting(false);
    }
  }, [contrasena, isSubmiting, navigate, usuario]);

  const handleSubmit = useCallback(
    async (event: LoginFormEvent) => {
      event.preventDefault();
      await handleLoginWithEmailPassword();
    },
    [handleLoginWithEmailPassword]
  );

  const canSubmit = formularioLoginEsValido(usuario, contrasena) && !isSubmiting;

  return {
    isSubmiting,
    canSubmit,
    handleUsuarioChange,
    handleContrasenaChange,
    handleSubmit,
    handleLoginWithEmailPassword,
  };
};
